
import { Component, Prop, Vue } from 'vue-property-decorator';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import GreyBoxForm from '@/components/utils/PopulateForms/components/GreyBoxForm.vue';
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import ScheduleHeader from '@/components/utils/PopulateForms/components/ScheduleHeader.vue';
import { getYourInformationResults } from "@/components/utils/PopulateForms/PopulateCommonInformation";
import { yourInformationInfoDataInfoType } from '@/types/Application/CommonInformation/Pdf';
import { contactInfoType, addressInfoType } from '@/types/Application/CommonInformation';
import { schedule1ChildInfoType, schedule1AnotherAdultInfoType, schedule1OtherChildrenInfoType, schedule1SharingAdultInfoType, schedule1BackgroundInfoType, schedule1YourStoryInfoType, schedule1NoGoInfoType, schedule1NoContactInfoType, schedule1WeaponsFirearmsInfoType, schedule1RemovePersonInfoType } from '@/types/Application/ProtectionOrder/PDF';

@Component({
    components: {
        UnderlineForm,
        GreyBoxForm,
        CheckBox,
        ScheduleHeader
    }
})
export default class Schedule1 extends Vue {

    @Prop({ required: true })
    result!: any;

    yourInfo = {} as yourInformationInfoDataInfoType;
    anotherAdult = {} as schedule1AnotherAdultInfoType;
    // Adding initial empty values to display an empty row in the table if no records exist
    childrenItem: schedule1ChildInfoType[] = [{ name: '', dob: '', myrelation: '', relation: '', living: '' }];
    sharingAdultItem: schedule1SharingAdultInfoType[] = [{ name: '', dob: '', relation: '' }];
    otherChildrenItem: schedule1OtherChildrenInfoType[] = [{ name: '', dob: '', protectedRelation: '', otherRelation: '', livingWith: '' }];
    otherAdultItem: schedule1AnotherAdultInfoType[] = [{ nameFull: '', dobBeauty: '' }];
    backgroundSurvey = {} as schedule1BackgroundInfoType;
    yourStory = {} as schedule1YourStoryInfoType;
    noGo = {} as schedule1NoGoInfoType;
    noContact = {} as schedule1NoContactInfoType;
    weaponsFirearms = {} as schedule1WeaponsFirearmsInfoType;
    removePerson = {} as schedule1RemovePersonInfoType;
    serviceAddress = {} as addressInfoType;
    serviceContact = {} as contactInfoType;

    hasSharingAdult = false;
    hasAnotherAdult = false;
    hasChildren = false;
    dataReady = false;
    applicantNeedsProtection = '';

    childrenFields = [
        { key: "name", label: "Child's full name", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:20%;" },
        { key: "dob", label: "Child's date of birth (mmm/dd/yyyy)", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:12.5%;" },
        { key: "myrelation", label: "My relationship to the child", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:13.75%;" },
        { key: "relation", label: "Other party's relationship to the child", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:13.75%;" },
        { key: "living", label: "Child is currently living with (name of person)", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:20%;" },
    ]

    sharingAdultFields = [
        { key: "name", label: "Full name", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:30%;" },
        { key: "dob", label: "Date of birth (mmm/dd/yyyy)", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:17%;" },
        { key: "relation", label: "Relationship to other protected person(s)", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:20%;" },
    ]

    otherChildrenFields = [
        { key: "name", label: "Child's full name", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:20%;" },
        { key: "dob", label: "Child's date of birth (mmm/dd/yyyy)", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:12.5%;" },
        { key: "protectedRelation", label: "My relationship to the child", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:13.75%;" },
        { key: "otherRelation", label: "Other party's relationship to child", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:13.75%;" },
        { key: "livingWith", label: "Child is currently living with (name of person)", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:20%;" },
    ]

    otherAdultFields = [
        { key: "fullName", label: "Full name of other person to be protected", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:20%;" },
        { key: "dobBeauty", label: "Date of birth (dd/mmm/yyyy)", tdClass: "border-dark text-center", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:12.5%;" },
    ]
    mounted() {
        this.dataReady = false;
        this.yourInfo = this.getYourInfo()
        this.getServiceInfo();
        this.getProtectingPeople();
        this.getOtherChildrenInfo();
        this.getNoGo();
        this.getNoContact();
        this.getWeaponsFirearms();
        this.getRemovePerson();
        this.getYourStory();
        this.getbackgroundSurvey();
        this.dataReady = true;
    }

    public getYourInfo() {

        if (this.result?.yourinformationPOSurvey) {
            return getYourInformationResults(this.result.yourinformationPOSurvey);
        }
        else
            return {} as yourInformationInfoDataInfoType;
    }

    public getServiceInfo() {
        if (this.result?.yourinformationPOSurvey?.Lawyer == 'y') {
            this.serviceAddress = this.result.yourinformationPOSurvey.LawyerAddress
            this.serviceContact = this.result.yourinformationPOSurvey.LawyerContact
        } else if (this.result?.yourinformationPOSurvey) {
            this.serviceAddress = this.result.yourinformationPOSurvey.ApplicantAddress
            this.serviceContact = this.result.yourinformationPOSurvey.ApplicantContact
        }
    }

    public getProtectingPeople() {

        this.hasChildren = false;
        this.hasSharingAdult = false;
        this.hasAnotherAdult = false;
        this.applicantNeedsProtection = '';

        if (this.result?.protectionFromWhomSurvey?.ApplicantNeedsProtection)
            this.applicantNeedsProtection = this.result?.protectionFromWhomSurvey?.ApplicantNeedsProtection

        if ( //Add Child info IF:
            (this.result?.protectionFromWhomSurvey?.childPO == 'y' && this.result?.protectionFromWhomSurvey?.ApplicantNeedsProtection == "y")
            || (this.result?.protectionFromWhomSurvey?.childPO == 'y' && this.result?.protectionFromWhomSurvey?.ApplicantNeedsProtection == "n" && this.result?.protectionFromWhomSurvey?.anotherAdultPO == 'n')
        ) {
            this.childrenItem = [];
            this.hasChildren = true;
            for (const child of this.result.protectionFromWhomSurvey.allchildren) {
                this.childrenItem.push({
                    name: Vue.filter('getFullName')(child.childName),
                    dob: Vue.filter('beautify-date')(child.childDOB),
                    myrelation: child.childRelationshipWithProtected,
                    relation: child.childRelationship,
                    living: child.childLivingWith
                })
            }
        }

        if ( //Add Sharing resident's Adult info IF:
            (this.result?.protectionFromWhomSurvey?.anotherAdultSharingResi == 'y') &&
            (this.result?.protectionFromWhomSurvey?.ApplicantNeedsProtection == 'y' ||
                this.result?.protectionFromWhomSurvey?.anotherAdultPO == 'y' ||
                this.result?.protectionFromWhomSurvey?.childPO == 'y')
        ) {
            this.sharingAdultItem = [];
            this.hasSharingAdult = true;
            for (const sharingAdult of this.result.protectionFromWhomSurvey.allAnotherAdultsSharingResi) {
                this.sharingAdultItem.push({
                    name: Vue.filter('getFullName')(sharingAdult.anotherAdultSharingResiName),
                    dob: Vue.filter('beautify-date')(sharingAdult.anotheradultSharingResiDOB),
                    relation: sharingAdult.anotherAdultSharingResiRelation
                })
            }
        }

        if ( //Add Apply for another Adult
            this.result?.protectionFromWhomSurvey?.anotherAdultPO == 'y' &&
            this.result?.protectionFromWhomSurvey?.ApplicantNeedsProtection == "n"
        ) {
            this.hasAnotherAdult = true;
            this.anotherAdult = {
                nameFull: Vue.filter('getFullName')(this.result.protectionFromWhomSurvey.anotherAdultName),
                dobBeauty: Vue.filter('beautify-date')(this.result.protectionFromWhomSurvey.anotherAdultDOB),
                reason: this.result.protectionFromWhomSurvey.anotherAdultReasonForPO
            }
        }
    }

    public getOtherChildrenInfo() {

        if (this.result?.backgroundSurvey?.PartiesHasOtherChilderen == 'y') {
            this.otherChildrenItem = [];
            for (const child of this.result.backgroundSurvey.allOtherChilderen) {
                this.otherChildrenItem.push({
                    name: Vue.filter('getFullName')(child.childName),
                    dob: Vue.filter('beautify-date')(child.childDOB),
                    protectedRelation: child.childRelationshipWithProtected,
                    otherRelation: child.childRelationshipWithOther,
                    livingWith: child.childLivingWith
                })
            }
        }
    }

    public getNoGo() {
        this.noGo = { places: [], otherComment: '' };

        if (this.result?.noGoSurvey?.RespondentNoGo == 'y' && this.result?.noGoSurvey?.RespondentNoGoPlaces) {
            this.noGo.places = this.result.noGoSurvey.RespondentNoGoPlaces

            if (this.result.noGoSurvey.RespondentNoGoPlaces.includes('other') && this.result.noGoSurvey.RespondentNoGoPlacesComment)
                this.noGo.otherComment = this.result.noGoSurvey.RespondentNoGoPlacesComment
        }
    }

    public getNoContact() {
        this.noContact = { reasonForComm: [], otherComment: '' };

        if (this.result?.noContactSurvey?.needCommunication == 'y' && this.result?.noContactSurvey?.reasonForCommunication) {
            this.noContact.reasonForComm = this.result.noContactSurvey.reasonForCommunication

            if (this.result.noContactSurvey.reasonForCommunication.includes('other') && this.result.noContactSurvey.reasonForCommunicationComment)
                this.noContact.otherComment = this.result.noContactSurvey.reasonForCommunicationComment
        }
    }

    public getWeaponsFirearms() {
        this.weaponsFirearms = { firearms: '', firearmsReason: '', firearmsYes: '', firearmsYesReason: '', weapons: '', weaponsReasons: '', weaponsYes: '', weaponsYesReason: '' }

        if (this.result?.weaponsFirearmsSurvey?.RespondentFirearms) {
            this.weaponsFirearms.firearms = this.result.weaponsFirearmsSurvey.RespondentFirearms;

            if (this.result.weaponsFirearmsSurvey.RespondentFirearms == 'y' && this.result.weaponsFirearmsSurvey.firearmsReason)
                this.weaponsFirearms.firearmsReason = this.result.weaponsFirearmsSurvey.firearmsReason
        }

        if (this.result?.weaponsFirearmsSurvey?.RespondentFirearmsYes) {
            this.weaponsFirearms.firearmsYes = this.result.weaponsFirearmsSurvey.RespondentFirearmsYes

            if (this.result.weaponsFirearmsSurvey.RespondentFirearmsYes == 'y' && this.result.weaponsFirearmsSurvey.firearmsYesReason)
                this.weaponsFirearms.firearmsYesReason = this.result.weaponsFirearmsSurvey.firearmsYesReason
        }

        if (this.result?.weaponsFirearmsSurvey?.RespondentWeapons) {
            this.weaponsFirearms.weapons = this.result.weaponsFirearmsSurvey.RespondentWeapons;

            if (this.result.weaponsFirearmsSurvey.RespondentWeapons == 'y' && this.result.weaponsFirearmsSurvey.weaponsReasons)
                this.weaponsFirearms.weaponsReasons = this.result.weaponsFirearmsSurvey.weaponsReasons
        }

        if (this.result.weaponsFirearmsSurvey.RespondentWeaponsYes) {
            this.weaponsFirearms.weaponsYes = this.result.weaponsFirearmsSurvey.RespondentWeaponsYes

            if (this.result.weaponsFirearmsSurvey.RespondentWeaponsYes == 'y' && this.result.weaponsFirearmsSurvey.weaponsYesReason)
                this.weaponsFirearms.weaponsYesReason = this.result.weaponsFirearmsSurvey.weaponsYesReason
        }
    }

    public getRemovePerson() {
        this.removePerson = { liveTogether: '', needPolice: [], needPoliceComment: '' }
        if (this.result?.removePersonSurvey?.RespondentLiveTogether) {
            this.removePerson.liveTogether = this.result.removePersonSurvey.RespondentLiveTogether

            if (this.result?.removePersonSurvey?.needPolice) {
                this.removePerson.needPolice = this.result.removePersonSurvey.needPolice;

                if (this.result.removePersonSurvey.needPolice.includes('other') && this.result.removePersonSurvey.needPoliceComment)
                    this.removePerson.needPoliceComment = this.result.removePersonSurvey.needPoliceComment
            }
        }
    }

    public getYourStory() {
        this.yourStory = { isViolence: '', whatViolence: '', isConcerns: '', whatConcerns: '', recentIncidents: '' }
        if (this.result?.yourStorySurvey?.isFamilyViolence) {
            this.yourStory.isViolence = this.result.yourStorySurvey.isFamilyViolence;
            if (this.result.yourStorySurvey.isFamilyViolence == 'y' && this.result.yourStorySurvey.whatViolence)
                this.yourStory.whatViolence = this.result.yourStorySurvey.whatViolence
        }

        if (this.result?.yourStorySurvey?.isNoneExplainedConcerns) {
            this.yourStory.isConcerns = this.result.yourStorySurvey.isNoneExplainedConcerns;
            if (this.result.yourStorySurvey.isNoneExplainedConcerns == 'y' && this.result.yourStorySurvey.noneExplainedConcerns)
                this.yourStory.whatConcerns = this.result.yourStorySurvey.noneExplainedConcerns
        }

        if (this.result?.yourStorySurvey?.recentIncidents)
            this.yourStory.recentIncidents = this.result.yourStorySurvey.recentIncidents
    }

    public getbackgroundSurvey() {

        this.backgroundSurvey = {
            married: '',
            protectedSpouse: '',
            liveTogetherDate: '',
            marriageDate: '',
            seperated: '',
            separationDate: '',
            howPartiesRelated: '',
            hasOtherChilderen: '',
            existingOrders: '',
            culturalExplain: '',
            mentalHealthConcern: '',
            mentalHealthConcernReasons: '',
            riskOfViolence: '',
            violenceCirumstances: '',
            existingPOOrders: '',
            disobeyOrder: '',
            describeDisobeyOrder: '',
            concernForNotObeying: '',
            explainNotObeyingConcern: '',
            reportedToPolice: '',
            policeActions: '',
            reportedToSW: '',
            swAction: ''
        }

        if (this.result?.backgroundSurvey?.howPartiesRelated)
            this.backgroundSurvey.howPartiesRelated = this.result.backgroundSurvey.howPartiesRelated

        if (this.result?.backgroundSurvey?.werePOPartiesMarried) {

            this.backgroundSurvey.married = this.result.backgroundSurvey.werePOPartiesMarried

            if (this.result.backgroundSurvey.werePOPartiesMarried == 'y') {
                this.backgroundSurvey.protectedSpouse = Vue.filter('getFullName')(this.$store.state.Application.protectedPartyName)
                this.backgroundSurvey.liveTogetherDate = Vue.filter('beautify-date-blank')(this.result.backgroundSurvey.liveTogetherPODate)
                this.backgroundSurvey.marriageDate = Vue.filter('beautify-date-blank')(this.result.backgroundSurvey.dateOfMarriagePO)

                if (this.result?.backgroundSurvey?.isSeperatedPO) {
                    this.backgroundSurvey.seperated = this.result.backgroundSurvey.isSeperatedPO
                    if (this.result.backgroundSurvey.isSeperatedPO == 'Yes')
                        this.backgroundSurvey.separationDate = Vue.filter('beautify-date')(this.result.backgroundSurvey.separationDate)
                }
            }
        }

        if (this.result?.backgroundSurvey?.PartiesHasOtherChilderen) {
            this.backgroundSurvey.hasOtherChilderen = this.result.backgroundSurvey.PartiesHasOtherChilderen;
        }

        if (this.result?.backgroundSurvey?.ExistingOrders && (this.childrenItem[0]?.name || this.otherChildrenItem[0]?.name))
            this.backgroundSurvey.existingOrders = this.result.backgroundSurvey.ExistingOrders;

        if (this.result?.backgroundSurvey?.likeToAddCulturalExplanation == 'y' && this.result?.backgroundSurvey?.culturalExplain) {
            this.backgroundSurvey.culturalExplain = this.result.backgroundSurvey.culturalExplain
        }

        if (this.result?.backgroundSurvey?.mentalHealthConcernPO) {
            this.backgroundSurvey.mentalHealthConcern = this.result.backgroundSurvey.mentalHealthConcernPO;
            if (this.result.backgroundSurvey.mentalHealthConcernPO == 'y' && this.result.backgroundSurvey.explainReasonsPO)
                this.backgroundSurvey.mentalHealthConcernReasons = this.result.backgroundSurvey.explainReasonsPO;
        }

        if (this.result?.backgroundSurvey?.riskOfViolencePO) {
            this.backgroundSurvey.riskOfViolence = this.result.backgroundSurvey.riskOfViolencePO
            if (this.result.backgroundSurvey.riskOfViolencePO == 'y' && this.result.backgroundSurvey.describeCirumstancesPO)
                this.backgroundSurvey.violenceCirumstances = this.result.backgroundSurvey.describeCirumstancesPO;
        }

        if (this.result?.backgroundSurvey?.existingPOOrders)
            this.backgroundSurvey.existingPOOrders = this.result.backgroundSurvey.existingPOOrders

        if (this.result?.backgroundSurvey?.otherPartyDisobeyOrder) {
            this.backgroundSurvey.disobeyOrder = this.result.backgroundSurvey.otherPartyDisobeyOrder;
            if (this.result.backgroundSurvey.otherPartyDisobeyOrder == 'Yes' && this.result.backgroundSurvey.describeDisobeyOrder)
                this.backgroundSurvey.describeDisobeyOrder = this.result.backgroundSurvey.describeDisobeyOrder
        }

        if (this.result?.backgroundSurvey?.concernForNotObeying) {
            this.backgroundSurvey.concernForNotObeying = this.result.backgroundSurvey.concernForNotObeying;
            if (this.result.backgroundSurvey.concernForNotObeying == 'y' && this.result.backgroundSurvey.explainReasonsForConcern)
                this.backgroundSurvey.explainNotObeyingConcern = this.result.backgroundSurvey.explainReasonsForConcern;
        }

        if (this.result?.backgroundSurvey?.reportedConcernsToPolice) {
            this.backgroundSurvey.reportedToPolice = this.result.backgroundSurvey.reportedConcernsToPolice;
            if (this.result.backgroundSurvey.reportedConcernsToPolice == 'y' && this.result.backgroundSurvey.describeActionsByPolice)
                this.backgroundSurvey.policeActions = this.result.backgroundSurvey.describeActionsByPolice;
        }

        if (this.result?.backgroundSurvey?.reportedConcernsToSW) {
            this.backgroundSurvey.reportedToSW = this.result.backgroundSurvey.reportedConcernsToSW;
            if (this.result.backgroundSurvey.reportedConcernsToSW == 'y' && this.result.backgroundSurvey.desrcibeSWAction)
                this.backgroundSurvey.swAction = this.result.backgroundSurvey.desrcibeSWAction
        }
    }
}
